import dynamic from "next/dynamic";
import { STFooter, STHeader } from "@/components";

const STCookies = dynamic(() => import("@/components/STCookies").then((mod) => mod.STCookies), {
  ssr: false,
});

const MainLayout = ({ children }) => {
  return (
    <>
      <STHeader />
      <main>{children}</main>
      <STCookies />
      <STFooter />
    </>
  );
};

export default MainLayout;
